import React, { useState, useEffect, useContext } from "react";

import "./TextInput.css";

const TextInput = ({ className, ...props }) => (
  <input className={`input ${className || ""}`} {...props} />
);

export default TextInput;
